<script lang="ts">
    import {OfferItem, Side} from "../../entities/OfferItem";
    import {ExtraType} from "../../entities/LedExtras";
    import InfoButton from "./InfoButton.svelte";

    export let updateFormData: Function;
    export let currentItem: OfferItem;
    export let selectedSide: string;
    let glass = false
    let zip = false
    let parapet = false
    let side: Side
    export let modalId: number

    function setModalId(id: number) {
        modalId = id
    }

    $ : {
        if (currentItem) {
            if (selectedSide)
                glass = getSideExtra(0)
            zip = getSideExtra(1)
            parapet = getSideExtra(2)
        }
    }

    function setExtra(selected: ExtraType, side: ExtraType): ExtraType {
        if (selected === side)
            return ExtraType.NONE
        switch (side) {
            case ExtraType.GLASS: {
                if (selected === ExtraType.ZIPSCREEN) {
                    return ExtraType.GLASS_ZIPSCREEN
                } else
                    return selected
            }
            case ExtraType.GLASS_ZIPSCREEN: {
                if (selected === ExtraType.GLASS)
                    return ExtraType.ZIPSCREEN
                else if (selected === ExtraType.ZIPSCREEN)
                    return ExtraType.GLASS
                else
                    return selected
            }
                break;
            case ExtraType.PARAPET: {
                if (selected === ExtraType.ZIPSCREEN)
                    return ExtraType.PARAPET_ZIPSCREEN
                else
                    return selected
            }
                break;
            case ExtraType.PARAPET_ZIPSCREEN: {
                if (selected === ExtraType.PARAPET)
                    return ExtraType.ZIPSCREEN
                else if (selected === ExtraType.ZIPSCREEN)
                    return ExtraType.PARAPET
                else
                    return selected
            }
                break;
            case ExtraType.ZIPSCREEN: {
                if (selected === ExtraType.GLASS)
                    return ExtraType.GLASS_ZIPSCREEN
                else if (selected === ExtraType.PARAPET)
                    return ExtraType.PARAPET_ZIPSCREEN
                else
                    return selected
            }
                break;
            case ExtraType.NONE:
                return selected
        }
    }

    function setSide(selected: ExtraType) {
        const newRef = new Side()
        switch (selectedSide) {
            case "LEFT" : {
                side = new Side(currentItem.left.wall, setExtra(selected, currentItem.left.extra))
                Object.assign(newRef, side);
                updateFormData({
                    left: newRef
                })
            }
                break;
            case "RIGHT" : {
                side = new Side(currentItem.right.wall, setExtra(selected, currentItem.right.extra))
                Object.assign(newRef, side);
                updateFormData({
                    right: newRef
                })
            }
                break;
            case "CLOSE" : {
                side = new Side(currentItem.close.wall, setExtra(selected, currentItem.close.extra))
                Object.assign(newRef, side);
                updateFormData({
                    close: newRef
                })
            }
                break;
            case "FAR" : {
                side = new Side(currentItem.far.wall, setExtra(selected, currentItem.far.extra))
                Object.assign(newRef, side);
                updateFormData({
                    far: newRef
                })
            }
                break;
        }
    }

    function getSideExtra(type: number) {
        switch (selectedSide) {
            case "LEFT" : {
                switch (type) {
                    case 0 :
                        return currentItem.left.extra === ExtraType.GLASS || currentItem.left.extra === ExtraType.GLASS_ZIPSCREEN
                    case 1 :
                        return currentItem.left.extra === ExtraType.ZIPSCREEN || currentItem.left.extra === ExtraType.GLASS_ZIPSCREEN || currentItem.left.extra === ExtraType.PARAPET_ZIPSCREEN
                    case 2 :
                        return currentItem.left.extra === ExtraType.PARAPET || currentItem.left.extra === ExtraType.PARAPET_ZIPSCREEN
                }
            }
                break;
            case "RIGHT" : {
                switch (type) {
                    case 0 :
                        return currentItem.right.extra === ExtraType.GLASS || currentItem.right.extra === ExtraType.GLASS_ZIPSCREEN
                    case 1 :
                        return currentItem.right.extra === ExtraType.ZIPSCREEN || currentItem.right.extra === ExtraType.GLASS_ZIPSCREEN || currentItem.right.extra === ExtraType.PARAPET_ZIPSCREEN
                    case 2 :
                        return currentItem.right.extra === ExtraType.PARAPET || currentItem.right.extra === ExtraType.PARAPET_ZIPSCREEN
                }
            }
                break;
            case "CLOSE" : {
                switch (type) {
                    case 0 :
                        return currentItem.close.extra === ExtraType.GLASS || currentItem.close.extra === ExtraType.GLASS_ZIPSCREEN
                    case 1 :
                        return currentItem.close.extra === ExtraType.ZIPSCREEN || currentItem.close.extra === ExtraType.GLASS_ZIPSCREEN || currentItem.close.extra === ExtraType.PARAPET_ZIPSCREEN
                    case 2 :
                        return currentItem.close.extra === ExtraType.PARAPET || currentItem.close.extra === ExtraType.PARAPET_ZIPSCREEN
                }
            }
                break;
            case "FAR" : {
                switch (type) {
                    case 0 :
                        return currentItem.far.extra === ExtraType.GLASS || currentItem.far.extra === ExtraType.GLASS_ZIPSCREEN
                    case 1 :
                        return currentItem.far.extra === ExtraType.ZIPSCREEN || currentItem.far.extra === ExtraType.GLASS_ZIPSCREEN || currentItem.far.extra === ExtraType.PARAPET_ZIPSCREEN
                    case 2 :
                        return currentItem.far.extra === ExtraType.PARAPET || currentItem.far.extra === ExtraType.PARAPET_ZIPSCREEN
                }
            }
                break;
        }
    }
</script>
{#if selectedSide}
    <div class="flex flex-wrap justify-evenly">
        <div class="flex flex-col items-center space-y-2 items-center relative text-center m-2" style="display: {currentItem.measuredModel.model.id === 1 || currentItem.measuredModel.model.id === 2? 'inline-flex' : 'none' }">
            <input type="checkbox" name="extra" class="extra" id="insulatedPanels"
                   checked={currentItem.insulatedPanel}
                   on:click={() => {
                        updateFormData({
                            insulatedPanel: !currentItem.insulatedPanel
                        })
                   }}/>
            <label class="cursor-pointer mx-3 img-label" for="insulatedPanels">
                <img src="/img/gc_panel_insulation.jpg" alt="Insulated panel" class="h-20 rounded shadow-lg">
                <span class="absolute bottom-0 left-0 py-1 bg-blue-700 rounded text-sm bg-opacity-70 w-full rounded-br rounded-bl">Hőszigetelt lamella</span>
            </label>
            <InfoButton bind:modalId={modalId} id={0}/>
        </div>
        <div class="flex flex-col items-center space-y-2  items-center relative text-center m-2">
            <input type="checkbox" name="extra" class="extra" id="parapet"
                   checked={parapet}
                   on:click={() => setSide(ExtraType.PARAPET)}/>
            <label class="cursor-pointer mx-3 img-label" for="parapet">
                <img src="/img/gc_parapet.jpg" alt="parapet" class="h-20 rounded shadow-lg">
                <span class="absolute bottom-0 left-0 py-1 bg-blue-600 rounded text-sm bg-opacity-80 w-full rounded-br rounded-bl">Parapet rendszer</span>
            </label>
            <InfoButton bind:modalId={modalId} id={1}/>
        </div>
        <div class="flex flex-col items-center space-y-2  items-center relative text-center m-2">
            <input type="checkbox" name="extra" class="extra" id="zipScreen"
                   checked={zip}
                   on:click={() => setSide(ExtraType.ZIPSCREEN)}/>
            <label class="cursor-pointer mx-3 img-label" for="zipScreen">
                <img src="/img/gc_screen.jpg" alt="zipscreen" class="h-20 rounded shadow-lg">
                <span class="absolute bottom-0 left-0 py-1 bg-blue-600 rounded text-sm bg-opacity-70 w-full rounded-br rounded-bll">Zip Screen</span>
            </label>
            <InfoButton bind:modalId={modalId} id={2}/>
        </div>
        <div class="flex flex-col items-center space-y-2 items-center relative text-center m-2">
            <input type="checkbox" name="extra" class="extra" id="glassSystem"
                   checked={glass}
                   on:click={() => setSide(ExtraType.GLASS)}/>
            <label class="cursor-pointer mx-3 img-label" for="glassSystem">
                <img src="/img/gc_sliding_glass.jpg" alt="glass" class="h-20 rounded shadow-lg">
                <span class="absolute bottom-0 left-0 py-1 bg-blue-600 rounded text-sm bg-opacity-70 w-full rounded-br rounded-bl">Tolható üvegfal</span>
            </label>
            <InfoButton bind:modalId={modalId} id={3}/>
        </div>
    </div>
{:else}
    <div class="w-full h-full flex-justify-center items-center p-6">
        <p>Válaszd ki a megfelelő oldalt a modellen, majd megjelenik egy menü a kiválasztható extrákkal.</p>
    </div>
{/if}

